import Button from '../ui/Button';
import Reveal from '../ui/Reveal';

/** Bloc d'appel à l'action affiché avant le footer sur toutes les pages. */
export default function PreFooter() {
  return (
    <section className="bg-surface py-20 text-black md:py-28">
      <div className="site-container">
        <Reveal className="max-w-3xl">
          <h2 className="text-inherit font-display text-[2.5rem] font-bold normal-case leading-[1.05] tracking-normal md:text-[4rem]">Prêt à travailler ensemble ?</h2>
          <p className="mt-6 max-w-2xl text-[1.0625rem] leading-relaxed text-ink">
            Que vous ayez un projet de construction, de rénovation ou d'ingénierie, notre équipe vous accompagne de l'étude à la réalisation.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Button to="/contact">Démarrer un projet</Button>
            <Button to="/portfolio" variant="secondary">Voir nos réalisations</Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
